import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.local';

import { IWorkoutApi } from './interfaces/workout-abstract.api';
import { ApiHttpResponse, Workout } from '@kinomap-dev/ng-ui-lib';

@Injectable({
  providedIn: 'root',
})
export class WorkoutApi implements IWorkoutApi {
  constructor(private readonly http: HttpClient) { }

  addToFavorite(workoutId: number | string): Observable<{ success: true }> {
    const url: string = `${environment.api.dashboard.workout.favorite}/${workoutId}`;
    return this.http.post<{ success: true }>(url, {});
  }

  deleteWorkout(workoutId: number): Observable<{ success: true }> {
    const url: string = environment.api.dashboard.deleteWorkout.replace(
      '{workout}',
      workoutId.toString()
    );
    return this.http.delete<{ success: true }>(url);
  }

  getWorkouts(
    page: number,
    limit: number
  ): Observable<ApiHttpResponse<Workout[]>> {
    const params: HttpParams = new HttpParams()
      .set('page', page)
      .set('limit', limit);
    const url: string = environment.api.dashboard.myWorkouts;
    return this.http.get<ApiHttpResponse<Workout[]>>(url, { params });
  }

  removeToFavorite(workoutId: number | string) {
    const url: string = `${environment.api.dashboard.workout.favorite}/${workoutId}`;
    return this.http.delete<{ success: true }>(url, {});
  }
}
